<template>
  <div class="w-full border-b-8 border-orange-400">
    <div class="w-full mx-auto md:w-3/4">
      <div class="flex flex-col justify-between lg:flex-row">
        <router-link to="/" class="block py-6 mx-auto lg:mx-0">
          <img alt="Bobbe Harris" src="../assets/template/main-logo.png" />
        </router-link>
        <div class="flex flex-col">
          <p class="flex-1 hidden py-5 text-2xl text-right text-blue-800 lg:block">
            Life Is Uphill All The Way...
            <br />You Need A Perspective
          </p>
          <div class="flex flex-row justify-center space-x-3 text-center">
            <router-link
              to="/about"
              class="block px-2 py-1 text-lg font-bold bg-white rounded-lg rounded-b-none hover:bg-orange-400 hover:text-white"
            >About</router-link>
            <router-link
              to="/under-construction"
              class="block px-2 py-1 text-lg font-bold bg-white rounded-lg rounded-b-none hover:bg-orange-400 hover:text-white"
            >
              <span class="md:hidden">UC</span>
              <span class="hidden md:block">Under Construction</span>
            </router-link>
            <router-link
              to="/project"
              class="block px-2 py-1 text-lg font-bold bg-white rounded-lg rounded-b-none hover:bg-orange-400 hover:text-white"
            >Project</router-link>
            <router-link
              to="/preview"
              class="block px-2 py-1 text-lg font-bold bg-white rounded-lg rounded-b-none hover:bg-orange-400 hover:text-white"
            >Preview</router-link>
            <router-link
              to="/purchase"
              class="block px-2 py-1 text-lg font-bold bg-white rounded-lg rounded-b-none hover:bg-orange-400 hover:text-white"
            >Purchase</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {
    msg: String
  }
};
</script>
